// extracted by mini-css-extract-plugin
export default {"levelIndicators":"levelIndicators_levelIndicators__faPyR","indicatorContainer":"levelIndicators_indicatorContainer__MW9T3","hidden":"levelIndicators_hidden__Y74dt"};